import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, createFileRoute } from "@tanstack/react-router";
import Loading from "../components/core/blocks/Loading";
import { TrellisPanelSignUp } from "../modules/auth/TrellisPanelSignUp";
import ExtensionSignUpMarketingPanel from "../modules/auth/ExtensionSignUpMarketingPanel";
import SignUpForm from "../modules/auth/SignUpForm";
import { Flex, Grid } from "../../styled-system/jsx";
import { css } from "../../styled-system/css";
import { forwardSignedInUser } from "../modules/auth/routeGuards";
import { LanguageSwitcher } from "../i18n/LanguageSwitcher";

function SignupPage() {
  const { t } = useTranslation("auth");
  const searchStr = useLocation({ select: (l) => l.searchStr });

  const extensionSignup = searchStr.includes("source=extension") || !!localStorage.extensionSignup;

  useEffect(() => {
    if (extensionSignup && !localStorage.extensionSignup) {
      localStorage.extensionSignup = new Date().toISOString().split("T")[0];
    }
  }, [extensionSignup]);

  useEffect(() => {
    document.title = t(($) => $.auth.signup["Sign Up For Trellis"]);

    let descriptionMeta = document.head.querySelector('meta[name="description"]');
    if (!descriptionMeta) {
      descriptionMeta = document.createElement("meta");
      descriptionMeta.setAttribute("name", "description");
      document.head.appendChild(descriptionMeta);
    }
    descriptionMeta.setAttribute(
      "content",
      t(
        ($) => $.auth.signup["Automate your Amazon ads with Trellis. Increase your sales while saving time and money."],
      ),
    );
  }, [t]);

  const handleScrollClick = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  return (
    <Grid className={css({ maxWidth: "100vw", background: "#FFF", position: "relative" })} columns={{ base: 1, lg: 2 }}>
      <div
        className={css({
          position: "absolute",
          top: "medium",
          right: "medium",
          zIndex: 1,
        })}
      >
        <LanguageSwitcher />
      </div>
      <Flex
        css={{
          display: { base: "none", md: "block" },
          alignItems: "center",
          height: "100vh",
        }}
      >
        {extensionSignup ?
          <ExtensionSignUpMarketingPanel />
        : <TrellisPanelSignUp handleScrollClick={handleScrollClick} />}
      </Flex>
      <SignUpForm extensionSignup={extensionSignup} />
    </Grid>
  );
}

export const Route = createFileRoute("/signup")({
  beforeLoad: forwardSignedInUser,
  pendingComponent: () => <Loading height="100vh" />,
  component: SignupPage,
});
